import React, { useEffect, useState } from "react";
import Ships from "./child/ShipDetails";
import ShipMainEngineDetails from "./child/MainEngineDetails";
import AuxilaryEngine from "./child/AuxilaryEngineDetails";
import Boiler from "./child/BoilerDetails";
import Pumps from "./child/PumpDetails";
import Crane from "./child/CraneDetails";
import ShipCompressorDetails from "./child/CompressorDetails";
import ShipPurifierDetails from "./child/PurifierDetails";
import { useParams } from "react-router-dom";
import AlarmView from "./child/AlarmView";
import AddTanks from "./child/AddTanks";
import SubTabMachinary from "./child/SubTabMachinary";
import SubTabCargoMachinary from "./child/SubTabCargoMachinary";

function EditShip() {
  const { id } = useParams();
  const [activeTab, set_activeTab] = useState("ship");
  useEffect(() => {
    const savedTab = localStorage.getItem("selectedTab");
    const lastSelectedKey = savedTab === "orbConfiguration" ? "addTanks" : savedTab || activeTab;
    set_activeTab(lastSelectedKey);
    if (savedTab === "orbConfiguration") localStorage.setItem("selectedTab", "addTanks");
  }, []);

  const handleClick = (name) => {
    set_activeTab(name);
    localStorage.setItem("selectedTab", name);
  };

  const handleSuccess = (currentTab) => {
    const tabOrder = [
      "ship",
      "main",
      "auxiliaryEngine",
      "auxiliaryMachinary",
      "cargoMachinary",
      "alarm",
      "addTanks",
    ];
    const currentIndex = tabOrder.indexOf(currentTab);
    if (currentIndex !== -1 && currentIndex < tabOrder.length - 1) {
      const nextTab = tabOrder[currentIndex + 1];
      set_activeTab(nextTab);
      localStorage.setItem("selectedTab", nextTab);
      window.scrollTo(0, 0);
    }
  };

  return (
    <>
      <div className="white-container">
        <ul className="marine-tabs">
          <li className={activeTab === "ship" ? "active" : ""} onClick={() => handleClick("ship")}>
            Ship Basic Details
          </li>
          <li className={activeTab === "main" ? "active" : ""} onClick={() => handleClick("main")}>
            Ship Main Engine
          </li>
          <li
            className={activeTab === "auxiliaryEngine" ? "active" : ""}
            onClick={() => handleClick("auxiliaryEngine")}
          >
            Ship Auxiliary Engine
          </li>
          <li
            className={activeTab === "auxiliaryMachinary" ? "active" : ""}
            onClick={() => handleClick("auxiliaryMachinary")}
          >
            Auxiliary Machinary
          </li>

          <li
            className={activeTab === "cargoMachinary" ? "active" : ""}
            onClick={() => handleClick("cargoMachinary")}
          >
            Cargo Machinary
          </li>

          <li
            className={activeTab === "alarm" ? "active" : ""}
            onClick={() => handleClick("alarm")}
          >
            Alarm
          </li>
          <li
            className={activeTab === "addTanks" ? "active" : ""}
            onClick={() => handleClick("addTanks")}
          >
            Ship Tanks
          </li>
        </ul>
        {/* {componentMap[activeTab]} */}
        {activeTab == "ship" && <Ships id={id} onSuccess={() => handleSuccess("ship")} />}
        {activeTab == "main" && (
          <ShipMainEngineDetails id={atob(id)} onSuccess={() => handleSuccess("main")} />
        )}
        {activeTab == "auxiliaryEngine" && (
          <AuxilaryEngine id={atob(id)} onSuccess={() => handleSuccess("auxiliaryEngine")} />
        )}
        {activeTab == "auxiliaryMachinary" && (
          <SubTabMachinary id={atob(id)} onSuccess={() => handleSuccess("auxiliaryMachinary")} />
        )}
        {activeTab == "cargoMachinary" && (
          <SubTabCargoMachinary id={atob(id)} onSuccess={() => handleSuccess("cargoMachinary")} />
        )}
        {activeTab == "cranes" && <Crane id={atob(id)} />}
        {activeTab == "boilers" && <Boiler id={atob(id)} />}
        {activeTab == "pump" && <Pumps id={atob(id)} />}
        {activeTab == "compressor" && <ShipCompressorDetails id={atob(id)} />}
        {activeTab == "purifier" && <ShipPurifierDetails id={atob(id)} />}
        {activeTab == "alarm" && <AlarmView id={atob(id)} onSuccess={() => handleSuccess("alarm")} />}
        {activeTab == "addTanks" && (
          <AddTanks id={atob(id)} onSuccess={() => handleSuccess("addTanks")} />
        )}
      </div>
    </>
  );
}

export default EditShip;
